import React from "react";
import { Text, View } from "react-native";

import { IconView } from "./CommonWidget/Icons";
import { PrimaryCTA, SecondaryCTA } from "./CommonCTA";

import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";

export const UpsertCartItemView = (props) => {
    let item = props.item
    const viewStyle = props?.viewStyle ?? null
    return <View style={[AppStyles.flexRowCenter, viewStyle]}>
        <IconView icon={'substract_circle_blue.svg'}
            action={() => props.updateCartItem(false, item)} />
        <Text style={[TextStyle.text14xb, TextStyle.colorPrimary,
        TextStyle.alignCenter, { width: 46 }]}>{item?.quantity}</Text>
        <IconView icon={'add_circle_blue_filled.svg'}
            action={() => props.updateCartItem(true, item)} />
    </View>
}

export const AddItemToCartPrimaryView = (props) => {
    const item = props.item
    const viewStyle = props?.viewStyle ?? null
    return <PrimaryCTA action={() => props.action(item)}
        title={'Add'} width={84} paddingVertical={6} />
}

export const AddItemToCartSecondaryView = (props) => {
    const item = props.item
    const viewStyle = props?.viewStyle ?? null
    return <SecondaryCTA action={() => props.action(item)}
        title={'Add To Cart'} width={115} key={'deal_cta_' + item.dealId}
        paddingVertical={6} marginAuto={false} borderWidth={1} />
}